'use strict';

/**
 * @function
 * @description appends the parameter with the given name and value to the given url and returns the changed url
 * @param {String} url the url to which the parameter will be added
 * @param {String} name the name of the parameter
 * @param {String} value the value of the parameter
 */
export function appendParamToURL(url, name, value, replaceParam) {
    url = replaceParam ? removeParamFromURL(url, name) : url;

    // quit if the param already exists or if value is empty
    if ((!name || !value) || url.indexOf(name + '=') !== -1 || typeof value === 'undefined') {
        return url;
    }

    let separator = url.indexOf('?') !== -1 ? '&' : '?';

    return url + separator + name + '=' + encodeURIComponent(value);
}

/**
 * @function
 * @description remove the parameter and its value from the given url and returns the changed url
 * @param {String} url the url from which the parameter will be removed
 * @param {String} name the name of parameter that will be removed from url
 */
export function removeParamFromURL(url, name) {
    if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
        return url;
    }

    let hash,
        params,
        domain = url.split('?')[0],
        paramUrl = url.split('?')[1],
        newParams = [];

    // if there is a hash at the end, store the hash
    if (paramUrl.indexOf('#') > -1) {
        hash = paramUrl.split('#')[1] || '';
        paramUrl = paramUrl.split('#')[0];
    }

    params = paramUrl.split('&');

    for (let i = 0; i < params.length; i++) {
        // put back param to newParams array if it is not the one to be removed
        if (params[i].split('=')[0] !== name) {
            newParams.push(params[i]);
        }
    }

    return domain + '?' + newParams.join('&') + (hash ? '#' + hash : '');
}

/**
 * @function
 * @description appends the parameters to the given url and returns the changed url
 * @param {String} url the url to which the parameters will be added
 * @param {Object} params
 */
export function appendParamsToURL(url, params, replaceParam) {
    let _url = url;

    for (let key in params) {
        _url = appendParamToURL(_url, key, params[key], replaceParam);
    }

    return _url;
}

/**
 * @function
 * @description
 * @param {String} url
 */
export function toAbsoluteUrl(url) {
    if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
        url = '/' + url;
    }

    return url;
}

/**
 * @function
 * @description Extracts all parameters from a given query string into an object
 * @param {String} qs The query string from which the parameters will be extracted
 */
export function getQueryStringParams(qs, defaultValue = undefined) {
    if (!qs || qs.length === 0) {
        return {};
    }

    let params = {};

    // Use the String::replace method to iterate over each
    // name-value pair in the string.
    qs.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
        function($0, $1, $2, $3) {
            //Ensure an empty parameter value is set to `undefined` and not processed using `decodeURIComponent()`.
            params[$1] = $3 ? decodeURIComponent($3) : defaultValue;
        }
    );

    return params;
}

/**
 * @function
 * @description Serializes a form to an object
 * @param {HTMLNodeEl} form The form which is being submitted.
 */
export function serializeObject(form) {
    let object = {};

    form.querySelectorAll('[name]').forEach(function(field) {
        object[field.name] = field.value;
    });

    return object;
}

/**
 * @function
 * @description Loads JS file dynamically from given url
 * @param {String} url The url from which JS file will be dynamically loaded.
 */
export function loadJsFile(url) {
    return $('<script/>').appendTo($('head')).attr({
        type: 'text/javascript',
    }).attr('src', url);
}

export function updateQueryStringEl(queryStringParams) {
    let pageQueryStringEl = document.querySelector('[data-querystring]');

    if (pageQueryStringEl) {
        let newQueryString = appendParamsToURL('', queryStringParams);

        newQueryString = newQueryString.charAt(0) === '?' ? newQueryString.substring(1) : newQueryString;

        pageQueryStringEl.setAttribute('data-querystring', newQueryString);
    }
}

export function updateHistoryState(targetURL, customPathName, method = 'replaceState', stateObject = undefined, stateTitle = '') {
    let baseURL = window.location.origin + (customPathName || window.location.pathname),
        queryStringParams = targetURL ? getQueryStringParams(targetURL) : {},
        newURL = targetURL ? appendParamsToURL(baseURL, queryStringParams) : baseURL;

    if (targetURL) {
        updateQueryStringEl(queryStringParams);
    }

    window.history[method](stateObject, stateTitle, newURL);
}
